import { createApi } from "@reduxjs/toolkit/query/react";

import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type { IApiResponse } from "@/types";
import type {
  ILeaveGroup,
  ICreateLeaveGroupRequest,
  IUpdateLeaveGroupRequest,
} from "@/types/(company)/leaveGroup.interface";

export const companyLeaveGroupsApi = createApi({
  reducerPath: "companyLeaveGroupsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["LeaveGroups"],
  endpoints: (builder) => ({
    getAllLeaveGroups: builder.query<IApiResponse<ILeaveGroup[]>, void>({
      query: () => ({
        url: "/company/settings/leave-groups",
        method: "GET",
      }),
      providesTags: ["LeaveGroups"],
    }),
    getLeaveGroupById: builder.query<IApiResponse<ILeaveGroup>, number>({
      query: (id) => ({
        url: `/company/settings/leave-groups/${id}`,
        method: "GET",
      }),
      providesTags: ["LeaveGroups"],
    }),
    addLeaveGroup: builder.mutation<
      IApiResponse<ILeaveGroup>,
      ICreateLeaveGroupRequest
    >({
      query: (data) => ({
        url: "/company/settings/leave-groups",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LeaveGroups"],
    }),
    updateLeaveGroup: builder.mutation<
      IApiResponse<ILeaveGroup>,
      IUpdateLeaveGroupRequest
    >({
      query: ({ id, data }) => ({
        url: `/company/settings/leave-groups/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["LeaveGroups"],
    }),
    deleteLeaveGroup: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (id) => ({
        url: `/company/settings/leave-groups/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["LeaveGroups"],
    }),
  }),
});

export const {
  useGetAllLeaveGroupsQuery,
  useGetLeaveGroupByIdQuery,
  useAddLeaveGroupMutation,
  useUpdateLeaveGroupMutation,
  useDeleteLeaveGroupMutation,
} = companyLeaveGroupsApi;
